/*
 *
 * TermsAndConditionsDetailPopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 03-Feb-2025
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import TermsAndConditionsDetailPopup from './TermsAndConditionsDetailPopup'
import * as actionLayer from '../../modules/TerminalsManagementActions'
import { doPopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actionLayer, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  data: state?.TerminalsManagement?.tac || {},
  isLoading: state.loading?.local_modifyTac || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(TermsAndConditionsDetailPopup)
